import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { timing } from '@clearscore/rainbow.tokens';
import Image from '@clearscore/rainbow.image';

import styles from './background.css';

const Background = (props) => (
    <TransitionGroup className={styles.component}>
        <CSSTransition
            key={props.src}
            classNames={{
                enter: styles.transitionEnter,
                enterActive: styles.transitionEnterActive,
            }}
            timeout={parseInt(timing['rnb-timing-fast'], 10)}
        >
            <Image {...props} />
        </CSSTransition>
    </TransitionGroup>
);

Background.propTypes = Image.propTypes;

export default Background;
